import {Card, CardActionArea, CardContent, Radio, RadioGroup, SxProps, Theme} from "@mui/material";
import clsx from "clsx";
import {GlobalLayout, StyledTypography} from "../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {useRecoilValue} from "recoil";
import React from "react";

type TradeInBoxProps = {
   id: string,
   onClick: () => void,
   image: string,
   title: string,
   description: string,
   selected: boolean,
   disableIcons?: boolean
   sx?: SxProps<Theme>
   children?: React.ReactNode
}

export const TradeInBox = (props: TradeInBoxProps) => {
   const globalLayout = useRecoilValue(GlobalLayout);
   const classes = useTradeInBoxStyles();

   const cardIdClass = "c2s-" + props.id + "-box";

   return <RadioGroup name={"tradeinradiogroup"}>
      <Card sx={{borderRadius: 0, borderColor: globalLayout.widgets?.accessBoxBorder || undefined, ...props.sx}} variant={"outlined"} className={clsx(cardIdClass)}>
         <CardActionArea className={clsx(classes.root)} onClick={props.onClick}>
            {(!globalLayout.disableIcons && !props.disableIcons) && <div className={"c2s-frontpage-icon"} style={{width: '100px', paddingRight: '10px'}}>
               <img src={props.image} className={classes.logo} title={props.title} alt={'Select drop off method'}/>
            </div>}
            <div className={clsx(classes.details)} style={{width: '100%'}}>
               <CardContent className={classes.aligned}>
                  <StyledTypography type={"front"} variant={"h2"}>
                     {props.title}
                  </StyledTypography>
                  <StyledTypography type={"front"} variant={"body1"}>
                     {props.description}
                  </StyledTypography>
                  {props.children && (
                     <div style={{ marginTop: '6px' }}>
                        {props.children}
                     </div>
                  )}
               </CardContent>
            </div>
            <div className={clsx(classes.details)}>
               <CardContent className={classes.aligned}>
                  <Radio className={clsx(classes.radio)} value={props.id} checked={props.selected}/>
               </CardContent>
            </div>
         </CardActionArea>
      </Card>
   </RadioGroup>
}

const useTradeInBoxStyles = makeStyles({
   radio: {
      color: '#444444 !important',
      padding: 0,
      margin:0
   },
   root: {
      display: 'flex',
      justifyContent: 'space-between'
   },
   details: {
      display: 'flex',
      flexDirection: 'column',
   },
   aligned: {
      textAlign: 'left'
   },
   logo: {
      width: '100%'
   }
})
